/* eslint-disable @next/next/no-img-element */
import { useTheme } from '@mui/material/styles';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import OurCultureImage1 from 'assets/images/our-culture-img1.png';
import OurCultureImage2 from 'assets/images/our-culture-img2.png';
import OurCultureImage3 from 'assets/images/our-culture-img3.png';
import OurCultureImage4 from 'assets/images/our-culture-img4.png';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: '81px 0 99px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& img': {
      width: '100%',
    },
    alignItems: 'stretch',
  },
}));

export const OurCulture = () => {
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Container disableGutters>
      <StyledBox>
        <Box mr={upSm ? 2 : undefined} m={upSm ? undefined : 2}>
          <img src={OurCultureImage1.src} width="100%" alt="trip to wonderla" />
        </Box>

        <Box
          position="relative"
          mr={upSm ? 2 : undefined}
          m={upSm ? undefined : 2}
        >
          <img src={OurCultureImage2.src} width="100%" alt="trip to wonderla" />

          <Box
            position="absolute"
            sx={{
              backgroundColor: 'rgba(0, 139, 94, 0.8)',
              left: 0,
              top: 0,
              zIndex: 50,
              width: '100%',
              height: '100%',
              borderRadius: '10px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            }}
          >
            <Typography color="#fff" fontSize={30} fontWeight="bold">
              OUR CULTURE
            </Typography>
            <Typography
              color="#fff"
              fontSize={22}
              fontWeight={300}
              lineHeight="30px"
              sx={{ pb: '42px' }}
            >
              We work hard.
              <br />
              We party harder.
            </Typography>
          </Box>
        </Box>

        <Box mr={upSm ? 2 : undefined} m={upSm ? undefined : 2}>
          <img src={OurCultureImage3.src} width="100%" alt="trip to wonderla" />
        </Box>
        <Box m={upSm ? undefined : 2}>
          <img src={OurCultureImage4.src} width="100%" alt="trip to wonderla" />
        </Box>
      </StyledBox>
    </Container>
  );
};
